import type { Customer } from '@aspenware-library/types'

interface CustomerGetters<CUSTOMER> {
  getFirstName(customer?: CUSTOMER | null): string
  getLastName(customer?: CUSTOMER | null): string
  getInitials(customer?: CUSTOMER | null): string
  getAvatar(customer?: CUSTOMER | null): string | undefined
  isGuest(customer?: CUSTOMER | null): boolean
  isAdmin(customer?: CUSTOMER | null): boolean
  isCustomerImpersonated(customer?: CUSTOMER | null): boolean
}

function getFirstName(customer?: Customer): string {
  return customer?.FirstName || ''
}

function getLastName(customer?: Customer): string {
  return customer?.LastName || ''
}

function getInitials(customer?: Customer): string {
  return `${getFirstName(customer)?.charAt(0) || ''}${getLastName(customer)?.charAt(0) || ''}`.toUpperCase()
}

function getAvatar(customer: Customer): string | undefined {
  return customer?.AvatarUrl ? `/${customer.AvatarUrl}` : undefined
}

function isGuest(customer: Customer): boolean {
  return customer ? customer.IsGuest : true
}

function isAdmin(customer?: Customer): boolean {
  return !!customer?.IsAdmin
}

function isCustomerImpersonated(customer?: Customer | null): boolean {
  return !!customer?.IsCustomerImpersonated
}

export const customerGetters: CustomerGetters<Customer> = {
  getFirstName,
  getLastName,
  getInitials,
  getAvatar,
  isGuest,
  isAdmin,
  isCustomerImpersonated,
}
